import React from "react";
import moment from "moment";
import { useTranslation } from "react-i18next";

const EpisodeList = ({
  isActive,
  episodes,
  prepend,
  remove,
  activeEpisode,
  setActiveEpisode,
  errors,
  setFocus,
  setCurrentTab,
}) => {
  const { t } = useTranslation();

  const insertEpisodeHandler = () => {
    // setActiveEpisode((prev) => prev + 1);

    prepend({
      title: "",
      subtitle: "",
      description: "",
      release_date: "",
      release_time: "",
      file_url: "",
      hours: "",
      minutes: "",
      seconds: "",
      age_restriction: "",
      video_length: "",
    });

    // if (episodes?.length === 0 || typeof episodes === "undefined") {
    setActiveEpisode(0);
    setTimeout(() => {
      setFocus(`episodes.0.title`);
    }, 50);
    // }
  };

  const removeEpisodeHandler = (index) => {
    const newLength = episodes.length - 1;
    const activeIsDeleted = index === activeEpisode;

    if (newLength === 0) {
      setActiveEpisode(null);
    } else if (activeIsDeleted) {
      setActiveEpisode(0);
    }

    setTimeout(() => {
      remove(index);
    }, 10);
  };

  const selectEpisode = (index) => {
    window.scroll({
      left: 0,
      top: 0,
      behavior: "auto",
    });

    setActiveEpisode(null);
    setTimeout(() => {
      setActiveEpisode(index);
      setCurrentTab("new-episode");
    }, 10);
  };

  return (
    <div
      className={`col-12 col-md-4 col-bg-very-dark col-scrollable ${
        isActive ? "" : "d-none d-md-block"
      }`}
      id="sec-episodes"
    >
      <div className="row">
        <div className="col pt-3">
          <div className="p-2">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h2 className="m-0">{t("episodeList.mainTitle")}</h2>
              <button
                className="btn btn-sm btn-success"
                onClick={insertEpisodeHandler}
                type="button"
                id="create-new-episode-button"
              >
                <i className="bi bi-file-earmark-plus"></i>{" "}
                {t("episodeList.newButton")}
              </button>
            </div>
            {errors?.episodes?.message && !!!episodes?.length && (
              <div className="invalid-feedback">
                {t(errors?.episodes?.message)}
              </div>
            )}
            <ul className="list-episodes list-group list-group-flush list-unstyled">
              {episodes?.map((ep, index) => {
                const isActiveEpisode = index === activeEpisode;
                const isError =
                  Object.keys(errors?.episodes?.[index] || [])?.length > 0;

                const displayDate = ep.release_date
                  ? moment(ep.release_date).format("MMM D, YYYY")
                  : t("episodeList.episodeDateFallback");

                return (
                  <li
                    className={`episode-nav-item d-flex justify-content-between ${
                      isActiveEpisode ? "active" : ""
                    } ${isError ? "is-error" : ""}`}
                    key={ep.episodeId}
                  >
                    <div>
                      <h4
                        onClick={() => selectEpisode(index)}
                        id={`episode-${index}-title`}
                      >
                        {ep.title || t("episodeList.episodeTitleFallback")}
                      </h4>
                      <span onClick={() => selectEpisode(index)}>
                        {displayDate}
                      </span>
                    </div>
                    <div>
                      <ul className="actions list-unstyled">
                        <li>
                          <a
                            onClick={() => removeEpisodeHandler(index)}
                            href="#"
                          >
                            {t("episodeList.deleteLink")}
                          </a>
                        </li>
                      </ul>
                      <div className="d-flex align-items-end flex-column">
                        <i
                          className={`bi bi-exclamation-circle-fill ${
                            isError ? "" : "d-none"
                          }`}
                        ></i>
                      </div>
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EpisodeList;
